module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-switch-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.loading) ? _c('dof-spinner', {
    staticClass: "dof-switch-loading",
    attrs: {
      "type": _vm.loadingSrc
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "switch",
    staticClass: " weex-ct weex-div",
    class: [_vm.type === 'white' ? 'switch-white' : 'switch', _vm.checked && _vm.switchActiveClass, ("switch-" + _vm.type)],
    style: (_vm._px2rem(Object.assign({}, _vm.mrSwitchStyle, _vm.customStyle), 75)),
    attrs: {
      "accessible": true,
      "aria-label": _vm.blindHelptext,
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.changeHandler($event)
      }
    }
  }, [_c('div', {
    ref: "switchDot",
    staticClass: " weex-ct weex-div",
    class: [_vm.type === 'white' ? 'switch-white-dot' : 'switch-dot'],
    style: (_vm._px2rem(_vm.dotStyle, 75)),
    attrs: {
      "accessible": false,
      "aria-hidden": true,
      "weex-type": "div"
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76af8caf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76af8caf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-switch/index.vue
// module id = 630
// module chunks = 0 1